export default __webpack_public_path__ + "static/media/handshake_480px.3ee28231.png";